<template>
    <modal :modal-name="'filterModal'" :modal-class-name="'filter-modal'" @close="store.commit('OPEN_MODAL', '')" class="main-modal">
        <template #body>
            <div class="modal-header">
                <h4 class="title">Select the apartment with the specified parameters</h4>
                <div class="close-btn-box">
                    <button @click.prevent="store.commit('OPEN_MODAL', '')" class="close-modal">
                        <close-modal/>
                    </button>
                </div>
            </div>
            <div class="modal-content scroll-box" @click.stop>
                <div class="filters-row">
                    <div class="rooms-filter filter-col">
                        <div class="filter-title">Rooms</div>
                        <div class="checkbox-list">
                            <div class="form-group" v-for="room in rooms" :key="room.id">
                                <p class="checkbox-label" >{{room.id}}</p>
                                <label class="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        :value="room.number"
                                        v-model="selectedRooms"
                                        @change="changeRooms($event)">
                                    <span class="check-icon"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="floor-filter filter-col">
                        <div class="filter-title">Floor</div>
                        <div class="range-slider-box">
                            <Slider
                                class="floor-range-slider"
                                :min="1"
                                :max="14"
                                :step="1"
                                :merge="2"
                                @change="changeFloorValue($event)"
                                v-model="floor" />
                        </div>
                    </div>

                    <div class="area-filter filter-col">
                        <div class="filter-title">Area</div>
                        <div class="range-slider-box">
                            <Slider
                                class="area-range-slider"
                                :min="66"
                                :max="200"
                                :step="10"
                                :merge="20"
                                :format="{
                                    suffix: 'm' + '2',
                                }"
                                @change="changeAreaValue($event)"
                                v-model="area" />
                        </div>
                    </div>
                </div>

                <div class="apartments-table">
<!--                    <label>Filter by Name:</label>-->
<!--                    <input v-model="filters.name.value" style="margin-top: 50px; margin-bottom: 50px"/>-->
                    <VTable
                        :data="apartments"
                        :page-size="3"
                        :filters="filters"
                        v-model:currentPage="currentPage"
                        @totalPagesChanged="totalPages = $event;"
                    >
                        <template #head>
                            <VTh sortKey="rooms">
                                Rooms
                            </VTh>
                            <VTh sortKey="area">Area</VTh>
                            <VTh sortKey="floor">Floor</VTh>
                            <VTh sortKey="condition" class="condition-cell">Condition</VTh>
                        </template>
                        <template #body="{ rows }">
                            <tr v-for="row in rows" :key="row.id">
                                <td class="text-primary">{{ row.rooms }}</td>
                                <td>{{ row.area }}</td>
                                <td>{{ row.floor }}</td>
                                <td class="condition-cell" :class="row.condition === 'sold out' ? 'sold-out' : '' ">
                                    {{ row.condition }}
                                </td>
                            </tr>
                        </template>
                    </VTable>
                    <VTPagination
                        v-model:currentPage="currentPage"
                        :total-pages="totalPages"
                        :boundary-links="true"
                        :maxPageLinks="3"
                    >
<!--                        <template #firstPage>-->
<!--                            Go to first-->
<!--                        </template>-->

<!--                        <template #lastPage>-->
<!--                            Go to last-->
<!--                        </template>-->
                    </VTPagination>
                </div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import {ref} from "vue";
import { useStore } from 'vuex'
import Slider from '@vueform/slider'

const store = ref(useStore())
const components = {
    Slider,
}
const selectedRooms = ref([])
const apartments = ref([])
const currentPage = ref(1)
const totalPages = ref(1)


//vue smart-table-filter
const filters =  ref(
    {
        name: { value: '', keys: ['rooms'] }
    }
)

const area = ref([66, 200])
const floor = ref([1, 14])

const rooms = ref([
    {
        id: 1,
        number: 1,
    },
    {
        id: 2,
        number: 2,
    },
    {
        id: 3,
        number: 3,
    },
    {
        id: 4,
        number: 4,
    },
    {
        id: 5,
        number: 5,
    }
])
function changeRooms($event) {
    let selectedValue = $event.target.value

    if (selectedRooms.value.indexOf(selectedValue) === -1) {
        selectedRooms.value.push(selectedValue)
    } else {
        selectedRooms.value.splice(selectedRooms.value.indexOf(selectedValue), 1)
    }
    console.log('selectedRooms',selectedRooms.value)
}

function changeFloorValue($event) {
    console.log('$event.target.value', floor.value)
}
function changeAreaValue($event) {
    console.log('$event.target.value', area.value)
}

apartments.value = [
    {
        id: 1,
        rooms: 2,
        area: 66,
        floor: 1,
        condition: 'sold out'
    },
    {
        id: 2,
        rooms: 3,
        area: 84,
        floor: 2,
        condition: 'available'
    },
    {
        id: 3,
        rooms: 2,
        area: 66,
        floor: 2,
        condition: 'available'
    },
    {
        id: 4,
        rooms: 3,
        area: 84,
        floor: 1,
        condition: 'sold out'
    },
    {
        id: 5,
        rooms: 3,
        area: 84,
        floor: 5,
        condition: 'available'
    },
    {
        id: 6,
        rooms: 2,
        area: 66,
        floor: 10,
        condition: 'sold out'
    },
    {
        id: 7,
        rooms: 4,
        area: 120,
        floor: 5,
        condition: 'sold out'
    },
    {
        id: 8,
        rooms: 2,
        area: 66,
        floor: 10,
        condition: 'available'
    },
    {
        id: 9,
        rooms: 4,
        area: 120,
        floor: 7,
        condition: 'available'
    },
    {
        id: 10,
        rooms: 5,
        area: 200,
        floor: 14,
        condition: 'sold out'
    },
    {
        id: 11,
        rooms: 4,
        area: 120,
        floor: 12,
        condition: 'sold out'
    },
    {
        id: 12,
        rooms: 3,
        area: 88,
        floor: 6,
        condition: 'sold out'
    },

]

</script>
<style src="@vueform/slider/themes/default.css"></style>

